import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalAtaComponent } from 'src/app/shared/modals/modal-ata/modal-ata.component';
import { AceitesService } from '../../services/saude/aceites.service';
@Component({
  selector: 'app-atas',
  templateUrl: './atas.component.html',
  styleUrls: ['./atas.component.css']
})
export class AtasComponent {
  faEye = faEye;
  listaAnos: any;
  items: any;
  listaArquivos: any;
  loading: boolean = false;
  loadData: boolean = false;
  pdfSafeUrl!: SafeUrl;
  numeroPagina: any = null;
  pesquisa: Boolean = false;
  formData: FormGroup = new FormGroup({
    isPaginated: new FormControl(true),
    itemsPerPage: new FormControl(5),
    page: new FormControl(1),
    grupo: new FormControl(null, [Validators.required]),
    ano: new FormControl(null, [Validators.required]),
  });
  constructor(private aceitesService: AceitesService, private modalService: NgbModal) {
    this.aceitesService.getBaseAtas().subscribe({ next: (data: any) => { this.items = data; } });
  }
  loadYears(): any {
    if (this.formData.value.grupo) {
      this.listaAnos = this.items.find((element: any) => {
        if (element.grupo == this.formData.value.grupo) {
          return element.anos;
        }
      });
    }
  }
  yearChanged() {
    this.listaArquivos = null;
    this.pesquisa = false;
  }
  getFilter() {
    this.aceitesService.getAtas({
      itemsPerPage: this.formData.value.itemsPerPage,
      page: this.formData.value.page - 1,
      grupo: this.formData.value.grupo,
      ano: this.formData.value.ano
    }).subscribe(
      (data: any) => {
        this.listaArquivos = data;
        this.pesquisa = true;
      });
  }
  visualizarAta(id: any, fileName: string) {
    const modalRef = this.modalService.open(ModalAtaComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.nomeAta = fileName;
    modalRef.componentInstance.id = id;
  }
  onChangePagination(page: number) {
    if (this.formData.value.page != page)
      this.formData.value.page = page;
    this.getFilter();
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.formData.value.itemsPerPage = quantidade;
    if (this.formData.value.page != 1)
      this.formData.value.page = 1;
    else
      this.getFilter();
  }
}
